import { X } from "lucide-react";

export const inputCls = "w-full bg-[#0A0A0A] border border-white/15 focus:border-white outline-none px-3 py-2.5 text-sm transition-colors";
export const labelCls = "font-mono-accent text-[10px] tracking-[0.2em] uppercase text-white/40 block mb-1.5";
export const panelCls = "bg-[#121212] border border-white/10";

export function Field({ label, children }) {
  return (
    <div>
      <label className={labelCls}>{label}</label>
      {children}
    </div>
  );
}

export function Empty({ children, testid }) {
  return <div className="text-white/40 text-sm border border-white/10 bg-[#121212] p-6" data-testid={testid}>{children}</div>;
}

export function TabHeading({ children, action }) {
  return (
    <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
      <h2 className="font-display font-bold uppercase tracking-tight text-2xl">{children}</h2>
      {action}
    </div>
  );
}

export function Modal({ open, onClose, title, children, testid, wide }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/80 backdrop-blur-sm p-4 sm:p-8" data-testid={testid} onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className={`w-full ${wide ? "max-w-2xl" : "max-w-lg"} bg-[#0F0F0F] border border-white/15 my-4 animate-in fade-in duration-150`}>
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/10">
          <h3 className="font-display font-bold uppercase tracking-tight text-lg">{title}</h3>
          <button onClick={onClose} data-testid="modal-close" className="text-white/40 hover:text-white transition-colors"><X size={20} /></button>
        </div>
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
}

export function SubmitBtn({ children, ...props }) {
  return (
    <button {...props} className="inline-flex items-center gap-2 bg-white text-black font-bold uppercase tracking-widest text-xs px-6 py-3 hover:bg-white/85 transition-colors disabled:opacity-60">
      {children}
    </button>
  );
}

export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" }) : "—");
export const fmtDateTime = (d) => (d ? new Date(d).toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");
